import { IJudgmentProsecutionType } from '../../../APIPackage/CatalogsModule/interfaces/IJudgmentProsecutionType';
import { IKnmJudgmentProsecutionTypeSelectOption } from '../interfaces/IKnmJudgmentProsecutionTypeSelectOption';

export const createJudgmentProsecutionTypeSelectOption = (
  erknmJudgmentProsecutionType: IJudgmentProsecutionType,
): IKnmJudgmentProsecutionTypeSelectOption => ({
  ...erknmJudgmentProsecutionType,
  label: erknmJudgmentProsecutionType.name,
  value: erknmJudgmentProsecutionType.id,
});
